module.exports = __webpack_public_path__ + "static/img/id001.5e80ff82.jpg";